import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getCostCenter,
  getParticularPage,
  getNext,
  getPrevious,
  createCostCenter,
  updateCostCenter,
  handleSearch,
} from "./thunk";

const initialState = {
  costCenters: [],
  edit: false,
  costCenter: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingCostCenter: false,
  loadingNext: false,
  showCreateModal: false,
};

export const costCenterSlice = createSlice({
  name: "costCenter",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    costCenterEditSuccess: (state, action) => {
      state.edit = true;
      state.costCenter = state.costCenters.find((costCenter) => costCenter.id === action.payload);
    },
    clearAllCostCenter: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingCostCenter = false;
      state.costCenter = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCostCenter.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createCostCenter.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createCostCenter.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateCostCenter.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateCostCenter.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateCostCenter.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getCostCenter.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingCostCenter = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCostCenter.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingCostCenter = false;
        state.costCenters = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCostCenter.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingCostCenter = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, costCenterEditSuccess, clearAllCostCenter } = costCenterSlice.actions;

export default costCenterSlice.reducer;
